<template>
  <div class="myProjects">
    <el-row class="home">
      <el-col :span="16">
        <div>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>
              <clientNavSelector></clientNavSelector>
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects` }">My Projects</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects/${ipWorksheet.projectPk}` }"> {{ ipWorksheet.projectId }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects/inpatient/${$route.params.drgTableId}` }">Record Detail</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="30" v-if="loading">
      <el-col :span="24">
        <div v-loading="loading" element-loading-spinner="nucleus-loader"></div>
      </el-col>
    </el-row>
    <div class="coderContainerCard" style="min-height: 100px; margin-top: 10px;">
      <el-row :gutter="30" v-if="!loading">
        <el-col :span="16">
          <!-- <el-button class="hiaButton pull-right" icon="el-icon-document" size="mini" @click="openWorksheet" plain round>Worksheet</el-button> -->
          <h5 style="margin: 0px 0px 20px 0px">Audit Results</h5>
          <el-collapse id="reviewAccordion" v-model="activeNames" class="ipCollapse">
            <el-collapse-item name="demographics" title="Demographics">
              <coderInpatientDemographics style="margin: 0px 0px 20px 10px;" :worksheet="ipWorksheet" class="collapseContent"></coderInpatientDemographics>
            </el-collapse-item>
            <el-collapse-item name="dxs">
              <template slot="title">
                <span style="width: 100%;">
                  Diagnosis Codes
                  <span class="codeTotalHeader"> - {{ ipWorksheet.dxs.length }} Total</span>
                </span>
              </template>
              <coderInpatientDxs :worksheet="ipWorksheet" :readOnly="readOnly"></coderInpatientDxs>
            </el-collapse-item>
            <el-collapse-item name="pxs">
              <template slot="title">
                <span style="width: 100%;">
                  Procedure Codes
                  <span class="codeTotalHeader"> - {{ ipWorksheet.pxs.length }} Total</span>
                </span>
              </template>
              <coderInpatientPxs :worksheet="ipWorksheet" :readOnly="readOnly"></coderInpatientPxs>
            </el-collapse-item>
            <el-collapse-item v-if="ipWorksheet.cpts.length" name="cpts">
              <template slot="title">
                <span style="width: 100%;">
                  CPT Codes
                  <span class="codeTotalHeader"> - {{ ipWorksheet.cpts.length }} Total</span>
                </span>
              </template>
              <coderInpatientCpts :worksheet="ipWorksheet" :readOnly="readOnly"></coderInpatientCpts>
            </el-collapse-item>
            <el-collapse-item title="Audit Findings" name="auditFindings">
              <coderInpatientFindings :worksheet="ipWorksheet"></coderInpatientFindings>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :span="8" class="sticky">
          <h5 style="margin: 0px 0px 20px 0px">Responses</h5>
          <div style="font-size: 13px; padding: 0px 0px 5px 0px;" v-if="ipWorksheet.rebuttalsCompleted">Rebuttals Completed on {{ formatDate(ipWorksheet.rebuttalsCompleted) }}. All Rebuttal Responses are locked.</div>
          <coderInpatientResponses :drgTableId="ipWorksheet.drgTableID" :ipWorksheet="ipWorksheet" @dirty="unsavedChanges = $event" @GET_IP_WORKSHEET="GET_IP_WORKSHEET" :worksheet="ipWorksheet" :readOnly="readOnly"> </coderInpatientResponses>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import coderInpatientDemographics from './coderInpatientDemographics'
import coderInpatientDxs from './coderInpatientDxs'
import coderInpatientPxs from './coderInpatientPxs'
import coderInpatientFindings from './coderInpatientFindings'
import coderInpatientResponses from './coderInpatientResponses'
import coderInpatientCpts from './coderInpatientCpts'
import { format, parseISO } from 'date-fns'

export default {
  name: 'CoderInpatientReview',
  data: function() {
    return {
      loading: true,
      unsavedChanges: false,
      activeNames: ['demographics', 'dxs', 'pxs', 'auditFindings', 'cpts']
    }
  },
  components: {
    coderInpatientDemographics,
    coderInpatientDxs,
    coderInpatientPxs,
    coderInpatientFindings,
    coderInpatientResponses,
    coderInpatientCpts
  },
  methods: {
    ...mapActions('myProjects/', ['GET_IP_WORKSHEET']),
    ...mapMutations('rebuttals/', ['SET_REBUTTALS']),
    ...mapActions('dropdowns', ['GET_DROPDOWNS']),
    async getWorksheet() {
      try {
        this.loading = true
        await this.GET_IP_WORKSHEET(this.$route.params.drgTableId)
        // update vuex rebuttal - rebuttals are managed in vuex after this call
        this.SET_REBUTTALS(this.ipWorksheet.rebuttals)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$message({
          message: 'Error getting coder worksheet',
          type: 'error'
        })
        console.log(e)
      }
    },
    openWorksheet() {
      const cacheBuster = new Date().getTime()
      this.worksheetWindow = window.open(`/my-projects/inpatient/worksheet/${this.ipWorksheet.drgTableID}?dt=${cacheBuster}&fullscreen=true`, 'worksheet', 'height=850,width=1600')
    },
    confirmLeave() {
      return window.confirm('Changes you made may not be saved.')
    },
    confirmStayInDirtyForm() {
      return this.unsavedChanges && !this.confirmLeave()
    },
    beforeWindowUnload(e) {
      if (this.confirmStayInDirtyForm()) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmStayInDirtyForm()) {
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },
  created: async function() {
    this.loading = true
    await this.getWorksheet()
    this.loading = false
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('myProjects/', ['ipWorksheet']),
    readOnly() {
      return !!this.ipWorksheet.rebuttalsCompleted
    }
  },
  watch: {}
}
</script>

<style scoped>
h5 {
  margin: 0px 0px 20px 10px;
  font-size: 14px;
}

.sticky {
  position: sticky;
  top: 10px;
}

>>> .hiaTable tr td {
  border: none !important;
}

>>> .hiaTable th {
  border: none !important;
}

>>> .coderContainerCard {
  overflow: unset;
}
</style>
